import actionTypes from './actionTypes';

const INITIAL_STATE = {
  ticketsLoading: false,
  ticketsFailed: false,
  ticketsError: false,
  ticketsMessage: null,
  tickets: {},
  ticketsList: [],

  ticketByIdLoading: false,
  ticketByIdFailed: false,
  ticketByIdError: false,
  ticketByIdMessage: null,
  ticketById: {},

  replyToTicketLoading: false,
  replyToTicketFailed: false,
  replyToTicketError: false,
  replyToTicketMessage: null,

  closeTicketLoading: false,
  closeTicketFailed: false,
  closeTicketError: false,
  closeTicketMessage: null,

  userTicketsLoading: false,
  userTicketsFailed: false,
  userTicketsError: false,
  userTicketsMessage: null,
  userTicketsList: [],
  userTickets: {},

}


export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ALL_TICKETS_LOADING: {
      return {
        ...state,
        ticketsLoading: true,
        ticketsFailed: false,
        ticketsError: false,
        ticketsMessage: null,
        tickets: {},
        ticketsList: [],
      };
    };
    case actionTypes.FETCH_ALL_TICKETS_REJECT: {
      return {
        ...state,
        ticketsLoading: false,
        ticketsFailed: false,
        ticketsError: true,
        ticketsMessage: null,
        tickets: {},
        ticketsList: [],

      };
    };
    case actionTypes.FETCH_ALL_TICKETS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        ticketsLoading: false,
        ticketsFailed: true,
        ticketsError: false,
        ticketsMessage: message,
        tickets: {},
        ticketsList: [],

      };
    };
    case actionTypes.FETCH_ALL_TICKETS_SUCCESS: {
      return {
        ...state,
        ticketsLoading: false,
        ticketsFailed: false,
        ticketsError: false,
        ticketsMessage: null,
        tickets: { ...action.payload },
        ticketsList: [...action.payload.tickets],

      };
    };


    case actionTypes.FETCH_TICKET_BY_ID_LOADING: {
      return {
        ...state,
        ticketByIdLoading: true,
        ticketByIdFailed: false,
        ticketByIdError: false,
        ticketByIdMessage: null,
        ticketById: {},
      };
    };
    case actionTypes.FETCH_TICKET_BY_ID_REJECT: {
      return {
        ...state,
        ticketByIdLoading: false,
        ticketByIdFailed: false,
        ticketByIdError: true,
        ticketByIdMessage: null,
        ticketById: {},
      };
    };
    case actionTypes.FETCH_TICKET_BY_ID_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        ticketByIdLoading: false,
        ticketByIdFailed: true,
        ticketByIdError: false,
        ticketByIdMessage: message,
        ticketById: {},
      };
    };
    case actionTypes.FETCH_TICKET_BY_ID_SUCCESS: {
      return {
        ...state,
        ticketByIdLoading: false,
        ticketByIdFailed: false,
        ticketByIdError: false,
        ticketByIdMessage: null,
        ticketById: { ...action.payload },
      };
    };




    case actionTypes.REPLY_TO_TICKET_LOADING: {
      return {
        ...state,
        replyToTicketLoading: true,
        replyToTicketFailed: false,
        replyToTicketError: false,
        replyToTicketMessage: null,
      };
    };
    case actionTypes.REPLY_TO_TICKET_REJECT: {
      return {
        ...state,
        replyToTicketLoading: false,
        replyToTicketFailed: false,
        replyToTicketError: true,
        replyToTicketMessage: null,
      };
    };
    case actionTypes.REPLY_TO_TICKET_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        replyToTicketLoading: false,
        replyToTicketFailed: true,
        replyToTicketError: false,
        replyToTicketMessage: message,
      };
    };
    case actionTypes.REPLY_TO_TICKET_SUCCESS: {
      return {
        ...state,
        replyToTicketLoading: false,
        replyToTicketFailed: false,
        replyToTicketError: false,
        replyToTicketMessage: null,
      };
    };





    case actionTypes.CLOSE_TICKET_LOADING: {
      return {
        ...state,
        closeTicketLoading: true,
        closeTicketFailed: false,
        closeTicketError: false,
        closeTicketMessage: null,
      };
    };
    case actionTypes.CLOSE_TICKET_REJECT: {
      return {
        ...state,
        closeTicketLoading: false,
        closeTicketFailed: false,
        closeTicketError: true,
        closeTicketMessage: null,
      };
    };
    case actionTypes.CLOSE_TICKET_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        closeTicketLoading: false,
        closeTicketFailed: true,
        closeTicketError: false,
        closeTicketMessage: message,
      };
    };
    case actionTypes.CLOSE_TICKET_SUCCESS: {
      return {
        ...state,
        closeTicketLoading: false,
        closeTicketFailed: false,
        closeTicketError: false,
        closeTicketMessage: null,
      };
    };






    case actionTypes.USER_TICKETS_LOADING: {
      return {
        ...state,
        userTicketsLoading: true,
        userTicketsFailed: false,
        userTicketsError: false,
        userTicketsMessage: null,
        userTicketsList: [],
        userTickets: {},
      };
    };
    case actionTypes.USER_TICKETS_REJECT: {
      return {
        ...state,
        userTicketsLoading: false,
        userTicketsFailed: false,
        userTicketsError: true,
        userTicketsMessage: null,
        userTicketsList: [],
        userTickets: {},
      };
    };
    case actionTypes.USER_TICKETS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        userTicketsLoading: false,
        userTicketsFailed: true,
        userTicketsError: false,
        userTicketsMessage: message,
        userTicketsList: [],
        userTickets: {},
      };
    };
    case actionTypes.USER_TICKETS_SUCCESS: {
      return {
        ...state,
        userTicketsLoading: false,
        userTicketsFailed: false,
        userTicketsError: false,
        userTicketsMessage: null,
        userTicketsList: [...action.payload.tickets],
        userTickets: { ...action.payload },
      };
    };



    default:
      return state;
  }
};
